export default __webpack_public_path__ + "static/media/interaction-arrow-back-white.6aa4a335.svg";